import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Поддерживаемые валюты приложения
 */
export type Currency =
  | 'USD' | 'EUR' | 'RUB' | 'GBP' | 'JPY' | 'CNY' | 'INR' | 'KRW'
  | 'PLN' | 'TRY' | 'UAH' | 'KZT' | 'BRL' | 'CAD' | 'AUD' | 'NZD'
  | 'CHF' | 'SEK' | 'NOK' | 'DKK' | 'CZK' | 'HUF' | 'RON'
  | 'MXN' | 'SGD' | 'HKD' | 'THB' | 'ZAR';

interface CurrencyStore {
  /** Текущая валюта приложения */
  currency: Currency;
  
  /** Установить валюту */
  setCurrency: (currency: Currency) => void;
}

/**
 * Глобальный стор для управления валютой приложения
 * Сохраняет выбор валюты в localStorage
 */
export const useCurrencyStore = create<CurrencyStore>()(
  persist(
    (set) => ({
      currency: 'USD', // По умолчанию USD
      
      setCurrency: (currency) => set({ currency }),
    }),
    {
      name: 'app-currency', // ключ в localStorage
      // version — при изменении списка поддерживаемых валют или структуры стейта
      // бампаем и пишем migrate: (old, oldVersion) => ... для плавного апгрейда.
      version: 1,
    }
  )
);